<template>
  <div class="main">
    <Modal
      v-model="modalStep1"
      :title="modalTitle"
      :closable="false"
      :mask-closable="false"
      width="700"
    >
      <div class="modal-main">
        <RemarkCard>
          <p>
            {{ infoText }}
          </p>
        </RemarkCard>
        <div class="flex" style="padding-top: 16px">
          <p class="flex flexae" style="margin-right: 50px">
            已选账单数<span v-if="modelType===2">（取消教务确认）</span>：<strong>{{ selectionTableRows().length }}</strong>个
          </p>
          <p>
            月份：<strong>{{ detailsData.settleMonth }}</strong>
          </p>
        </div>
        <h2 style="padding: 10px 0 4px 0">机构名单:</h2>
        <div class="list">
          <ul>
            <li
              v-for="(item, index) in selectionTableRows()"
              :key="item.sheetId"
            >
              {{ item.orgName }}
            </li>
          </ul>
        </div>
      </div>
      <div slot="footer">
        <Button @click="handleCancelStep1">取消</Button>
        <Button type="primary" @click="handleOkStep1">确定</Button>
      </div>
    </Modal>

    <Modal
      v-model="modalStep2"
      title="确认处理结果"
      :closable="false"
      :mask-closable="false"
      width="1100"
    >
      <div class="color-gray" style="margin-bottom: 10px">
        <Icon
          type="ios-loading"
          size="18"
          class="spin-icon-load"
          color="blue"
        ></Icon>
        <span
          style="
            text-align: center;
            font-size: 14px;
            margin-top: 20px;
            font-weight: bold;
            margin-left: 4px;
          "
        >请耐心等待，系统正在处理您的操作，请勿关闭当前页面</span>
      </div>
      <div class="table-main">
        <Table :columns="columns" :data="tableData" border :max-height="450">
          <template slot="bankId" slot-scope="{ row }">
            <span>{{ getBankIdStr(row.bankId) }}</span>
          </template>
          <template slot="procSts" slot-scope="{ row }">
            <span :style="{ color: getProcStsColor(row.procSts) }">{{
              getProcStsStr(row.procSts)
            }}</span>
          </template>
        </Table>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="modalStep3"
      title="批量设置教务确认"
      :closable="false"
      :mask-closable="false"
      width="700"
    >
      <div class="modal-main">
        <p style="font-size: 18px; margin-bottom: 10px">
          处理成功：<span
            class="color-green"
            style="margin-right: 20px; font-size: 18px"
          >{{ successNum }}个{{
          }}</span>
          失败：<span
            class="color-red"
            style="font-size: 18px"
          >{{ failNum }}个</span>
        </p>
        <div class="list-main">
          <h2>处理失败的账单信息：</h2>
          <ul>
            <li v-for="(item, index) in failData" :key="index">
              {{ item.orgName }}（账单ID :{{ item.statementId }}）
              <span style="color: red">原因：{{ item.failStr }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handleOkStep3">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import RemarkCard from '@c/Base/RemarkCard.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import timer from '@/utils/timer.js';
export default {
  components: {
    RemarkCard
  },
  inject: ['selectionTableRows', 'detailsData'],
  data() {
    return {
      modalStep1: false,
      modalStep2: false,
      modalStep3: false,
      tableData: [],
      taskId: '',
      columns: [{
        title: '账单编号',
        key: 'statementId'
      }, {
        title: '机构名称',
        key: 'orgName'
      }, {
        title: '结算月份',
        key: 'settleMonth'
      }, {
        title: '银行',
        slot: 'bankId'
      }, {
        title: '状态',
        slot: 'procSts'
      }],
      successNum: 0,
      failNum: 0,
      failData: [],
      modelType: 1// 1：批量设置教务确认  2：批量取消教务确认
    };
  },
  computed: {
    modalTitle() {
      if (this.modelType === 1) {
        return '批量设置教务确认';
      } else {
        return '批量取消教务确认';
      }
    },
    infoText() {
      if (this.modelType === 1) {
        return ' ①教务提交确认即表示对本次账单结算金额确认无误，请根据实际情况进行审批操作。';
      } else {
        return '①教务取消确认即表示对本次账单结算进行取消教务确认操作，请根据实际情况进行审批操作。';
      }
    }
  },
  methods: {
    handleShow(type) {
      this.modelType = type;
      this.modalStep1 = true;
      this.modalStep2 = false;
      this.modalStep3 = false;
    },
    handleCancelStep1() {
      this.modalStep1 = false;
    },
    handleOkStep1() {
      if (this.modelType === 1) {
        this.batchAcademicAffairsApproval();
      } else {
        this.batchCancelAcademicAffairsApproval();
      }
    },
    handleOkStep3() {
      this.modalStep3 = false;
      location.reload();
    },
    getBankTypeStr(val) {
      const map = {
        1: '平安银行',
        2: '花都工行',
        3: '微信商户'
      };
      return (val || val === 0) ? map[Number(val)] : '';
    },
    getBankIdStr(v) {
      const map = {
        '0': '微信商户',
        '10001': '平安银行',
        '10002': '花都工行',
        '10003': '中山工行'
      };
      return (v || v === 0) ? map[Number(v)] : '';
    },

    getProcStsStr(val) {
      const map = {
        0: '待处理',
        1: '确认成功',
        2: '账单确认处理中....',
        3: '确认失败'
      };
      return (val || val === 0) ? map[Number(val)] : '';
    },
    getProcStsColor(val) {
      const map = {
        0: '#515A6E',
        1: '#19be6b',
        2: '#02affe',
        3: 'red'
      };
      return (val || val === 0) ? map[Number(val)] : '';
    },
    // 撤销待运营确认的审批账单
    async batchCancelAcademicAffairsApproval() {
      const rows = this.selectionTableRows();
      const parameter = [];
      rows.forEach(item => {
        parameter.push({
          sheetId: item.sheetId
          // totalDivideAmt: item.totalDivideAmt * 100
        });
      });
      this.$Spin.show();
      const res = await orderCenterApi.batchAcademicAffairsRevocationApprovalApi(parameter);
      this.$Spin.hide();
      if (res.status == 200) {
        this.taskId = res.message;
        //  localStorage.setItem('batchSettlementTaskId', res.message)
        this.modalStep1 = false;
        this.modalStep2 = true;
        this.getTaskStatusList();
        timer.addTimer('batchAcademicCheckTask', this.getTaskStatusList, 3000);
      } else {

      }
    },
    async batchAcademicAffairsApproval() {
      const rows = this.selectionTableRows();
      const parameter = [];
      rows.forEach(item => {
        parameter.push({
          sheetId: item.sheetId,
          totalDivideAmt: item.settleAvailAmt * 100
        });
      });
      this.$Spin.show();
      const res = await orderCenterApi.batchAcademicAffairsApproval(parameter);
      this.$Spin.hide();
      if (res.status == 200) {
        this.taskId = res.message;
        //  localStorage.setItem('batchSettlementTaskId', res.message)
        this.modalStep1 = false;
        this.modalStep2 = true;
        this.getTaskStatusList();
        timer.addTimer('batchAcademicCheckTask', this.getTaskStatusList, 3000);
      } else {

      }
    },
    async getTaskStatusList() {
      const params = {
        busiCode: this.modelType === 1 ? 12 : 21, //  业务编码 12-教务审批  21-教务撤销待运营审批
        pageSize: 100,
        pageNo: 1,
        // busiObjIds: [],
        upBatchIds: this.taskId ? [this.taskId] : [], // 父级任务id
        procStsList: this.taskId ? [] : [0, 2],
        exeFlag: 1
      };
      this.loading = true;
      const res = await courseSchedulCenter.getTaskStatusListApi(params);
      if (res.status == 200 && res.message.list.length > 0) {
        this.tableData = res.message.list.map(item => {
          return { ...item.properties, procSts: item.batchProcData.procSts };
        });
        this.checkTaskResult();
      } else {
        this.loading = false;
        timer.clearTimer('batchAcademicCheckTask');
      }
    },
    checkTaskResult() {
      const procIngs = this.tableData.filter(item => { return [0, 2].includes(Number(item.procSts)); });
      if (procIngs.length == 0) {
        timer.clearTimer('batchAcademicCheckTask');
        this.loading = false;
        if (this.taskId) {
          this.modalStep2 = false;
          this.modalStep3 = true;
          this.getTaskStatusInfo();
        }
      }
    },
    async getTaskStatusInfo() {
      const params = {
        busiCode: this.modelType === 1 ? 12 : 21, //  业务编码 12-教务审批  21-教务撤销待运营审批
        pageSize: 100,
        pageNo: 1,
        // busiObjIds: [],
        upBatchIds: this.taskId ? [this.taskId] : [], // 父级任务id
        procStsList: this.taskId ? [0, 1, 2, 3] : [0, 1, 2, 3],
        exeFlag: 1
      };
      this.$Spin.show();
      const res = await courseSchedulCenter.getTaskStatusListApi(params);
      this.$Spin.hide();
      if (res.status == 200) {
        const tableData = res.message.list.map(item => {
          return { ...item.properties, procSts: item.batchProcData.procSts, failStr: item.batchProcData.lineData3 };
        });
        this.successNum = tableData.filter(item => {
          return item.procSts == 1;
        }).length;
        this.failData = tableData.filter(item => {
          return item.procSts == 3;
        });
        this.failNum = this.failData.length;
      }
      this.$emit('on-success');
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 12px;
  max-height: 500px;
  overflow-y: scroll;
  ul {
  }
}
</style>
